export default __webpack_public_path__ + "static/media/svg-2.1ffe26a0.svg";